import React from 'react';
import { Eye, Pencil, Trash2 } from 'lucide-react';
import Button from './Button';

export default function ActionButtons({ onView, onEdit, onDelete, view = true, edit = true, remove = true }) {
  return (
    <div className="action-buttons">
      {view && (
        <Button variant="ghost" size="icon" onClick={onView} title="View">
          <Eye size={16} />
        </Button>
      )}
      {edit && (
        <Button variant="ghost" size="icon" onClick={onEdit} title="Edit">
          <Pencil size={16} />
        </Button>
      )}
      {remove && (
        <Button variant="ghost" size="icon" onClick={onDelete} title="Delete" className="text-danger">
          <Trash2 size={16} />
        </Button>
      )}
    </div>
  );
}
